import React from 'react';
import PropTypes from 'prop-types';
import Loading from './Loading';

const PageLoading = () => { 
    return (
        <div className="main">
            <div className="container">
                <div className="block-inner">
                    <div className="row">
                        <div className="col-md-12 minimal-height">
                            <div>Loading...</div>
                            <br />
                            <Loading/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageLoading;
